import { createAction, handleActions } from 'redux-actions'
import { get } from 'lodash'

const openRamsSigningModal = createAction('SCREENS/RAMSSIGNINGS/OPEN_RAMSSIGNING_MODAL')
const closeRamsSigningModal = createAction('SCREENS/RAMSSIGNINGS/CLOSE_RAMSSIGNING_MODAL')

const defaultState = {
  show: false,
  id: null,
}

const reducer = handleActions(
  {
    [openRamsSigningModal]: (state, action) => ({
      ...state,
      show: true,
      id: get(action, 'payload.id', null),
    }),
    [closeRamsSigningModal]: () => defaultState,
  },
  defaultState,
)

export { openRamsSigningModal, closeRamsSigningModal, reducer }
